import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'globot-subscription-success-modal',
  templateUrl: './subscription-success-modal.component.html',
  styleUrls: ['./subscription-success-modal.component.scss'],
})
export class SubscriptionSuccessModalComponent {
  @Input() visible: boolean = false;
  @Output() closed = new EventEmitter<void>();

  lottieOptions = {
    path: '/assets/lotties/check.json',
  };

  onClose(): void {
    this.closed.emit();
  }
}

